<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <div class="container">
      <vgtree ref="xTree" class="vgtree" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick">
          <template slot="btn">
              <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
          </template>
      </vgtree>

      <el-form :model="form" ref="form"  class="content ss-fl" v-if="reportform">
        <el-row>
          <el-col :span="5">
            <el-form-item label="序号" :label-width="formLabelWidth">
              <el-input v-model="form.reportseq" :maxlength="6" show-word-limit auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="上级" :label-width="formLabelWidth">
              <el-select v-model="form.reportparentid" :clearable="true" >
                <el-option v-for="(item, index) in reportList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="报表名" :label-width="formLabelWidth">
              <el-input v-model="form.reportname" :maxlength="40" show-word-limit auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="报表类型" :label-width="formLabelWidth">
              <el-select v-model="form.reporttype" :clearable="true">
                <el-option v-for="(item, index) in reporttypeList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item label="数据源" :label-width="formLabelWidth">
              <el-select v-model="form.reportdsid" :clearable="true" >
                <el-option v-for="(item, index) in dsList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="打印模板" :label-width="formLabelWidth">
              <el-input v-model="form.reporturl" :maxlength="255" show-word-limit type="textarea" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input v-model="form.reportremark" :maxlength="255" show-word-limit type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveReport">保存</el-button>
          <el-button type="danger" @click="delReport">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vgtree from '../common/vgtree1'
  import MenuBtn from "../common/menuBtn"
  export default {
    name: 'reportIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        reportform: false,
        dsList:[],
        reporttypeList:[],
        reportList: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'reportname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false}
        ],
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        },
        report: {},
        form: {},
        loading: true,
        formLabelWidth: '100px'
      }
    },
    created () {
      this.$on('ADD', () => this.addReport())
      this.$on('SAV', () => this.saveReport())
      this.$on('DEL', () => this.delReport())
      this.$on('SORT', () => this.sortReport())
      this.$on('FIELD', () => this.rfieldForm())
      this.$on('CLOSE', () => this.close())
      this.getReportList()
      this.getReporttypeList()
      this.getReportFolderList()
      this.getDsList()
    },
    mounted () {
    },
    watch: {
      $route() {
      }
    },
    components: {MenuBtn,vgtree},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async rfieldForm () {
        if (!this.report.reportid) {
          this.$message.warning('请选择一行!')
          return
        }
        this.$router.push({name: 'rfieldForm', params: {form: this.report}})
      },
      async addReport () {
        this.reportform = true
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.reportseq>maxSeq) {
            maxSeq = item.reportseq
          }
        })
        maxSeq += 10
        this.form = {
          reportid: 0,
          reportcomid: this.$store.getters.loginUser.usercomid,
          reportseq: maxSeq,
          reportcode: '',
          reportname: '',
          reporttype: '',
          reportdsid: '',
          reporturl: '',
          reportremark: ''
        }
      },
      async getReporttypeList() {
        this.reporttypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'reporttype'}
        })
      },
      async getDsList() {
        this.dsList = await request({
          url: '/xtgl/ds/getDsList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
      },
      async getReportFolderList() {
        this.reportList = await request({
          url: '/xtgl/report/getReportFolderList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.reportList.splice(0,0,{
          label: '无',
          value: 0
        })
      },
      async sortReport () {
        let data = await request({
          url: '/xtgl/report/sortReport',
          method: "post",
          data: this.list
        })
        if (data.issuccess === 1) {
          this.getReportList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }
      },
      async delReport () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/report/delReport',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getReportList()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveReport () {
        await request({
          url: '/xtgl/report/saveReport',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getReportList()
        this.reportform = false
      },
      async cellClick (row) {
        this.report = row.row
        this.form = row.row
        this.reportform = true
      },
      async getReportList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/report/getReportTree',
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.list = res.list
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vgtree {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
</style>
